import "./PolicyUpdatesBanner.scss";

import { FC } from "react";
import { useSelector } from "react-redux";

import Button from "components/Button/Button";
import Text from "components/Text/Text";
import { ConditionalLink, useAccountData, useTranslation } from "modules";
import { RootState } from "store";

const PolicyUpdatesBanner: FC = () => {
  const { t } = useTranslation();
  const { pendingQuote, userHasPolicy, userHasRUWCase } = useAccountData();
  const pendingPolicyId = useSelector((state: RootState) => state.pendingPolicy.id);
  const quoteId = pendingQuote?.id;
  const hasPolicy = userHasPolicy;
  const hasRUWCase = userHasRUWCase;

  const getBannerData = () => {
    if (hasPolicy && pendingPolicyId) {
      return {
        message: t("dashboard.policy.has_policy.pending_banner.title", "UPDATES PENDING"),
        ctaText: t("dashboard.policy.has_policy.pending_banner.cta", "SEE DETAILS"),
        ctaLink: `/products/insurance/${pendingPolicyId}/pending-details`,
      };
    }
    if (hasPolicy && hasRUWCase) {
      return {
        message: t("pending_banner.policy.ruw.message", "UPDATES PENDING"),
        ctaText: t("pending_banner.policy.ruw.cta", "SEE DETAILS"),
        ctaLink: "/products/insurance/manual-review",
      };
    }
    if (hasPolicy && quoteId) {
      return {
        message: t("pending_banner.policy.pending_quote.message", "PENDING YOUR APPROVAL"),
        ctaText: t("pending_banner.policy.pending_quote.cta", "REVIEW"),
        ctaLink: "/products/insurance/confirm-update",
      };
    }
    return { message: "", ctaText: "", ctaLink: "" };
  };

  const { message, ctaText, ctaLink } = getBannerData();

  if (message) {
    return (
      <div className="policy-updates-banner__container" data-testid="policy-updates-banner">
        <div className="policy-updates-banner__wrapper">
          <div className="policy-updates-banner__message">
            <Text tag="c5" text={message} />
          </div>
          <div className="policy-updates-banner__cta">
            <ConditionalLink condition={!!ctaLink} to={ctaLink}>
              <Button className="updates-banner__button" subtype="secondary" text={ctaText} />
            </ConditionalLink>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default PolicyUpdatesBanner;
